import { requestJSON } from './request'

export interface Page {
  id: number
  actions: PageAction[]
  slug: string
  status: number
  title: string
  title_fr: string
  title_en: string
  description: string
  description_fr: string
  description_en: string
  content: string
  content_fr: string
  content_en: string
}

export interface PageAction {
  id: number
  name: string
  name_fr: string
  name_en: string
  description: string
  description_fr: string
  description_en: string
  action: string
  action_fr: string
  action_en: string
  url: string
  thumbnail_128_crop: string
  thumbnail_256_crop: string
  thumbnail_368_256_crop: string
  is_featured: boolean
  hex_color: string
}

export async function getPages (): Promise<Page[]> {
  return await requestJSON('/api/pages/')
}

export async function getPage (pageId: number): Promise<Page> {
  return await requestJSON(`/api/pages/${pageId}/`)
}
